import { type HttpDelete, mapServerError } from '@/shared/infra/http'
import { GalleryPhotoNotFoundError } from '@/shared/domain'
import type { DeleteHuntSourcedPhoto } from '@/modules/gallery/use-cases'

export class SupabaseDeleteHuntSourcedPhotoRepository {
  constructor(private readonly http: HttpDelete) {}

  execute: DeleteHuntSourcedPhoto = async ({ id }) => {
    try {
      await this.http.delete<void>({
        url: `/hunt-photos/${encodeURIComponent(id)}`,
      })
    } catch (err) {
      mapServerError(err, {
        '404:not_found': GalleryPhotoNotFoundError,
      })
    }
  }
}
